import React from 'react';
import { cellCode, getRiskLevel, riskLabel, riskColours } from '../utils/riskUtils';
import './RiskSummary.css';

export interface RiskCoordinates {
  likelihood?: number | null;
  consequence?: number | null;
}

export default function RiskBadge({ likelihood, consequence }: RiskCoordinates) {
  const level = getRiskLevel(likelihood ?? 0, consequence ?? 0);
  return level ? <span className={`risk-summary-badge risk-colour-${level}`} style={{ ...riskColours[level], display: 'inline-flex', alignSelf: 'flex-start' }}>
    {cellCode(likelihood!, consequence!)} · {riskLabel(level)}
  </span> : <span className="risk-summary-unrated">Not rated</span>;
}
